export default __webpack_public_path__ + "static/ENG_Step_1-38bade2c22e2a00a2f0f0beb2f6222da.svg";